"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTracingContext = void 0;
const tslib_1 = require("tslib");
const api_1 = tslib_1.__importDefault(require("@opentelemetry/api"));
/**
 * Returns opentelemetry tracing context if available
 * otherwise returns empty object
 *
 * @package
 * @returns Partial<TracingContext>
 */
const getTracingContext = () => {
    var _a;
    const spanContext = (_a = api_1.default.trace.getSpan(api_1.default.context.active())) === null || _a === void 0 ? void 0 : _a.spanContext();
    if (!spanContext || !api_1.default.trace.isSpanContextValid(spanContext)) {
        return {};
    }
    return {
        traceId: spanContext.traceId,
        spanId: spanContext.spanId,
        traceFlags: `0${spanContext.traceFlags.toString(16)}`,
    };
};
exports.getTracingContext = getTracingContext;
//# sourceMappingURL=tracing.js.map